module.exports = __webpack_public_path__ + "img/image_circle_new.1a98783c.jpg";